/**
 * AnswerBox — 40–55 word, 3-sentence direct answer block.
 * Rendered immediately after the H1 so Google's featured-snippet
 * extractor lands on a clean, citable passage.
 *
 * The `id="answer-box"` is referenced by Speakable schema on the page,
 * unlocking voice-assistant answers without extra markup.
 */
export function AnswerBox({
  answer,
  className = "",
}: {
  answer: string;
  className?: string;
}) {
  return (
    <aside
      id="answer-box"
      role="note"
      aria-label="Quick answer"
      className={
        "mt-5 rounded-xl border-l-4 border-primary bg-primary/5 px-4 py-3 text-[15px] leading-relaxed text-foreground md:text-base " +
        className
      }
    >
      {answer}
    </aside>
  );
}